<template>
  <div class="accordion" id="accordion">
    <div class="card mb-3">
      <div id="card-header" class="card-header" data-toggle="collapse" data-target="#card-body" aria-expanded="false" aria-controls="card-body">
        <div class="row" data-bs-toggle="tooltip" data-bs-delay="500" title="Click to expand/collapse filters">
          <div class="col">
            <h6 class="m-0">Filters</h6>
          </div>
          <div class="col d-flex">
            <div class="ml-auto">
              <span class="expand-icon"><fa icon="chevron-down"/></span>
              <span class="collapse-icon"><fa icon="chevron-up"/></span>
            </div>
          </div>
        </div>
      </div>
      <div id="card-body" ref="card-body" class="collapse" aria-labelledby="card-header" data-parent="#accordion">
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-4 col-xl-3">
              <h6>
                Date Range
                <small>({{ dataRangeSelected }})</small>
                <button type="button" class="btn btn-sm btn-link" @click="resetDateRange">Reset</button>
              </h6>
              <v-date-picker mode="range" v-model="dateRange" :input-props="{ placeholder: 'Filter by a date range', readonly: true }" />
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6 col-lg-4">
              <h6>
                Regions
                <small>({{ countSelected(regions, selectedRegionIds) }})</small>
                <button type="button" class="btn btn-sm btn-link" @click="reset('selectedRegionIds')">Reset</button>
              </h6>
              <select class="custom-select" multiple size="6" v-model="selectedRegionIds">
                <option :value="item.id" v-for="item in regions" :key="item.id" @mousedown.prevent="mousedown('selectedRegionIds', item, $event)">{{
                  item.displayName
                }}</option>
              </select>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <h6>
                Facilities/Stores
                <small>({{ countSelected(facilities, selectedFacilityIds) }})</small>
                <button type="button" class="btn btn-sm btn-link" @click="reset('selectedFacilityIds')">Reset</button>
              </h6>
              <select class="custom-select" multiple size="6" v-model="selectedFacilityIds">
                <option :value="item.id" v-for="item in facilities" :key="item.id" @mousedown.prevent="mousedown('selectedFacilityIds', item, $event)">{{
                  item.displayName
                }}</option>
              </select>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <h6>
                Functions/Districts
                <small>({{ countSelected(functions, selectedFunctionIds) }})</small>
                <button type="button" class="btn btn-sm btn-link" @click="reset('selectedFunctionIds')">Reset</button>
              </h6>
              <select class="custom-select" multiple size="6" v-model="selectedFunctionIds">
                <option :value="item.id" v-for="item in functions" :key="item.id" @mousedown.prevent="mousedown('selectedFunctionIds', item, $event)">{{
                  item.displayName
                }}</option>
              </select>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <h6>
                Companies/Districts
                <small>({{ countSelected(companies, selectedCompanyIds) }})</small>
                <button type="button" class="btn btn-sm btn-link" @click="reset('selectedCompanyIds')">Reset</button>
              </h6>
              <select class="custom-select" multiple size="6" v-model="selectedCompanyIds">
                <option :value="item.id" v-for="item in companies" :key="item.id" @mousedown.prevent="mousedown('selectedCompanyIds', item, $event)">{{
                  item.displayName
                }}</option>
              </select>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <h6>
                Countries
                <small>({{ countSelected(countries, selectedCountryIds) }})</small>
                <button type="button" class="btn btn-sm btn-link" @click="reset('selectedCountryIds')">Reset</button>
              </h6>
              <select class="custom-select" multiple size="6" v-model="selectedCountryIds">
                <option :value="item.code" v-for="item in countries" :key="item.code" @mousedown.prevent="mousedown('selectedCountryIds', item, $event)">{{
                  item.displayName
                }}</option>
              </select>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <h6>
                States
                <small>({{ countSelected(states, selectedStateIds) }})</small>
                <button type="button" class="btn btn-sm btn-link" @click="reset('selectedStateIds')">Reset</button>
              </h6>
              <select class="custom-select" multiple size="6" v-model="selectedStateIds">
                <option :value="item.code" v-for="item in states" :key="item.code" @mousedown.prevent="mousedown('selectedStateIds', item, $event)">{{
                  item.displayName
                }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  props: {
    organizationId: String,
  },
  data() {
    return {
      loadingMessage: null,

      dateRange: {
        start: null,
        end: null,
      },

      regions: [],
      facilities: [],
      functions: [],
      companies: [],

      selectedRegionIds: [],
      selectedFacilityIds: [],
      selectedFunctionIds: [],
      selectedCompanyIds: [],
      selectedCountryIds: [],
      selectedStateIds: [],
    };
  },
  computed: {
    ...mapGetters("user", ["user"]),
    ...mapGetters("static", ["countries", "states"]),
    dataRangeSelected() {
      var diff = moment(this.dateRange.end).diff(this.dateRange.start, "days") + 1;
      var displayText = isNaN(diff) ? "All" : `${diff} day`;
      if (diff > 1) displayText += "s";
      return displayText;
    },
  },
  watch: {
    dateRange: {
      deep: true,
      handler() {
        this.$emit("changed");
      },
    },
    selectedRegionIds: {
      deep: true,
      handler() {
        this.$emit("changed");
      },
    },
    selectedCompanyIds: {
      deep: true,
      handler() {
        this.$emit("changed");
      },
    },
    selectedFacilityIds: {
      deep: true,
      handler() {
        this.$emit("changed");
      },
    },
    selectedFunctionIds: {
      deep: true,
      handler() {
        this.$emit("changed");
      },
    },
    selectedCountryIds: {
      deep: true,
      handler() {
        this.$emit("changed");
      },
    },
    selectedStateIds: {
      deep: true,
      handler() {
        this.$emit("changed");
      },
    },
  },
  created() {
    function asArrayOrDefault(value, defaultValue) {
      value = value || defaultValue;
      if (Array.isArray(value)) return value;
      if (value) return [value];
      return [];
    }

    // query strings
    this.dateRange.start = this.$route.query.startDate ? new Date(Number.parseInt(this.$route.query.startDate, 10) * 1000) : this.dateRange.start;
    this.dateRange.end = this.$route.query.endDate ? new Date(Number.parseInt(this.$route.query.endDate, 10) * 1000) : this.dateRange.end;
    this.selectedRegionIds = asArrayOrDefault(this.$route.query.region, this.selectedRegionIds);
    this.selectedFacilityIds = asArrayOrDefault(this.$route.query.facility, this.selectedFacilityIds);
    this.selectedCompanyIds = asArrayOrDefault(this.$route.query.company, this.selectedCompanyIds);
    this.selectedFunctionIds = asArrayOrDefault(this.$route.query.function, this.selectedFunctionIds);
    this.selectedCountryIds = asArrayOrDefault(this.$route.query.country, this.selectedCountryIds);
    this.selectedStateIds = asArrayOrDefault(this.$route.query.state, this.selectedStateIds);

    this.load();
  },
  methods: {
    load() {
      this.loadingMessage = "Loading...";

      var userId = this.user.id;
      var regions = this.$axios.get(`/v1/organizations/${this.organizationId}/users/${userId}/regions`).then(res => (this.regions = res.data));
      var facilities = this.$axios.get(`/v1/organizations/${this.organizationId}/users/${userId}/facilities`).then(res => (this.facilities = res.data));
      var functions = this.$axios.get(`/v1/organizations/${this.organizationId}/users/${userId}/functions`).then(res => (this.functions = res.data));
      var companies = this.$axios.get(`/v1/organizations/${this.organizationId}/users/${userId}/companies`).then(res => (this.companies = res.data));

      Promise.all([regions, facilities, functions, companies]).then(() => (this.loadingMessage = null));
    },
    countSelected(all, selected) {
      if (all.length === selected.length) return "All";
      if (selected.length === 0) return "All";
      return selected.length;
    },
    reset(name) {
      while (this[name].length > 0) this[name].pop();
    },
    resetDateRange() {
      this.dateRange = {
        start: null,
        end: null,
      };
    },
    mousedown(name, item, $event) {
      // multi-select without ctrl+click
      $event.target.selected = !$event.target.selected;
      var id = item.id || item.code;

      // remove
      var index = this[name].indexOf(id);
      if (index > -1) this[name].splice(index, 1);

      // add
      if ($event.target.selected) this[name].push(id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/base.scss";

.card:hover {
  overflow: visible;
}

.card-body {
  @extend .pt-0;
}

.col-12 {
  @extend .mt-3;
}

.card-header {
  cursor: pointer;
}

[aria-expanded="false"] {
  .collapse-icon {
    display: none;
  }
}

[aria-expanded="true"] {
  .expand-icon {
    display: none;
  }
}
</style>
